// extracted by mini-css-extract-plugin
export default {"textArea":"_a11dc1d4","error":"_95a806a6"};